import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const CreateSubscriptionContract = graphql(`
  mutation CreateSubscriptionContract(
    $input: CreateSubscriptionContractInput!
  ) {
    createSubscriptionContract(input: $input) {
      __typename
      ... on SubscriptionContractAggregate {
        id
      }
      ... on ExperimentalFeaturesNotAvailableError {
        errorName
        message
      }
      ... on UnauthorizedError {
        errorName
        message
      }
      ... on UnknownError {
        errorName
        message
      }
    }
  }
`);
export const createSubscriptionContract = async (params, { client }) => {
    const data = await client.core.request(CreateSubscriptionContract, {
        input: { ...params },
    });
    if (data.createSubscriptionContract.__typename ===
        "SubscriptionContractAggregate") {
        return data.createSubscriptionContract.id;
    }
    throw new Error(`Error creating subscription contract. ErrorName: ${data.createSubscriptionContract.errorName}. Message: ${data.createSubscriptionContract.message}`);
};
